import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import WWMuffinsProduct from 'models/WWMuffinsProduct'
import WWMuffinsPackage from './WWMuffinsPackage'

const productOptions = {
  packagingInfo: <WWMuffinsPackage />,
  productTitle: 'Whole Wheat English Muffins',
  model: WWMuffinsProduct,
  validCategories: ['16'],
  validSubCategories: ['011'],
}

const WWMuffins = () => <ProductForm product={productOptions} />

export default WWMuffins
